import { Decimal, LiquityStoreState, StabilityDeposit } from "@liquity/lib-base";
import { useLiquitySelector } from "@liquity/lib-react";
import { COIN } from "../../../strings";
import { SLSD } from "../../../lexicon";
import { twMerge } from 'tailwind-merge'
import { useAppState } from "../../../hooks/AppStateContext";
import { useCallback } from "react"

type Props = {
  className?: string
}

export const MyDeposit: React.FC<Props> = ({ className }) => {
  const { currentCollateralKey } = useAppState();

  const selector = useCallback(({ collateralStates }: LiquityStoreState) => {
    if (!currentCollateralKey) {
      return {
        price: Decimal.ZERO,
        stabilityDeposit: new StabilityDeposit(Decimal.ZERO, Decimal.ZERO, Decimal.ZERO, Decimal.ZERO)
      }
    }

    const { price, stabilityDeposit } = collateralStates[currentCollateralKey];
    return {
      price,
      stabilityDeposit,
    }
  }, [currentCollateralKey])

  const { stabilityDeposit } = useLiquitySelector(selector);
  // TODO-PSY: calculate depositedUSDValue with currentSLSD * SLSD price
  const depositedUSDValue = stabilityDeposit.currentSLSD.mul(1)

  return (
    <div className={twMerge(`bg-component border-component flex flex-row p-5 justify-between ${className}`)}>
      <div className="flex flex-col items-start w-full">
        <div className="text-style-sub">Your SLSD Deposited</div>
        <div className="flex flex-row items-center justify-between w-full md:flex-col md:items-start">
          <div className="flex flex-row items-center mt-4">
            <img src={SLSD.iconUrl} alt={SLSD.term} className="w-6 h-6"/>
            <div className="text-style-value ml-2">{stabilityDeposit.currentSLSD.prettify()} {COIN}</div>
          </div>
          <div className="text-style-sub mt-3">${depositedUSDValue.prettify()}</div>
        </div>
      </div>
    </div>
  )
}